import { CONSTANT } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest
} from '../../../helper/request-helper';

const fetchAccountsUrl = CONSTANT.baseUrl + ENDPOINTS.employee.account.fetchAccounts;

export const actionType = {
    REQUESTED_ACCOUNT_DATA: 'REQUESTED_ACCOUNT_DATA',
    REJECTED_ACCOUNT_DATA: 'REJECTED_ACCOUNT_DATA',
    FETCH_ACCOUNTS: 'FETCH_ACCOUNTS'
};

export const fetchAccounts = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_ACCOUNT_DATA
        });

        return generalHttpGetRequest(fetchAccountsUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_ACCOUNTS,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_ACCOUNT_DATA,
                    data: error
                });
                return error;
            });
    };
};




// WEBPACK FOOTER //
// ./src/services/redux/employee/account/actions.js